var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-hover-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('div',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.displayText))])]},proxy:true}])},[_c('div',{staticClass:"caption"},[_c('v-row',{staticClass:"pa-0"},[_c('v-col',{staticClass:"d-flex flex-nowrap pa-0"},[_vm._v(_vm._s(_vm.displayPrice))])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }